function IconMinus() {
  return (
    <svg viewBox="0 0 50 50">
      <path d="M24,33h0a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h0a9,9,0,0,1,9,9h0A9,9,0,0,1,24,33Zm-3-9h6m7,11-4.08-4.08" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
    </svg>
  );
}

export default IconMinus;
